import { Component, OnInit, Inject } from '@angular/core';
import { Handle } from 'src/app/handle';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-razon',
  templateUrl: './create-razon.component.html',
  styleUrls: ['./create-razon.component.scss']
})
export class CreateRazonComponent implements OnInit {

  
  constructor(private dialogRef: MatDialogRef<CreateRazonComponent>, public Handle: Handle,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService) { }
  operacion = 'createrazon';
  idrazon = '';
  idpais;

  ngOnInit() {
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editrazon';
      this.idrazon = this.data.razon.IDRAZON;
      this.grupoVal.controls.NOMBRE.setValue(this.data.razon.NOMBRE);
    } else {
      this.idpais = this.data.razon.IDPAIS;
    }
  }

  save() {
    let RAZON = {
      NOMBRE: this.grupoVal.controls.NOMBRE.value,
      IDRAZON: this.idrazon,
      IDPAIS: this.idpais

    }

    this.gateway.save(this.operacion, RAZON).then((result) => {
      this.dialogRef.close();
    }
    ).catch(function (e) {
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(50)
    ])]),
  });

}
